import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * Romanian CNP validator following Single Responsibility Principle
 */
export class CnpValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Romanian CNP',
      pattern: /^\d{13}$/,
      length: 13
    });
  }

  validateFormat(id) {
    // Check length
    const lengthValidation = this.validateLength(id, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    return this.validateRegex(
      id,
      this.config.pattern,
      'CNP must be exactly 13 digits'
    );
  }

  validateChecksum(id) {
    const weights = [2, 7, 9, 1, 4, 6, 3, 5, 8, 2, 7, 9];
    let sum = 0;

    for (let i = 0; i < 12; i++) {
      sum += parseInt(id[i]) * weights[i];
    }

    let expectedChecksum = sum % 11;
    if (expectedChecksum === 10) {
      expectedChecksum = 1;
    }

    const actualChecksum = parseInt(id[12]);

    if (expectedChecksum !== actualChecksum) {
      return ValidationResult.invalid(`Invalid CNP checksum. Expected: ${expectedChecksum}, Got: ${actualChecksum}`);
    }

    return ValidationResult.valid('Valid CNP');
  }
}